function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M15.8531 19.3706C14.039 19.3706 12.5186 17.8889 12.5186 16.0361C12.5186 14.1833 14.0003 12.7041 15.8531 12.7041C17.7059 12.7041 19.1876 14.1859 19.1876 16.0387C19.1876 17.8914 17.6673 19.3706 15.8531 19.3706ZM20.4065 9.29489H11.2972C10.0757 9.29489 9.11194 10.2587 9.11194 11.4801V20.592C9.11194 21.8135 10.0757 22.7773 11.2972 22.7773H20.4091C21.6305 22.7773 22.5943 21.8135 22.5943 20.592V11.4827C22.5943 10.2973 21.6305 9.29489 20.4065 9.29489Z",
  fill: "#8E8B99"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M29.1499 11.2224C29.1499 9.03722 28.2969 6.96281 26.7431 5.40893C25.1866 3.85248 23.1122 3.00211 20.9296 3.00211V4.37302C22.7437 4.37302 24.4857 5.07651 25.7819 6.3727C27.0781 7.66888 27.7816 9.37222 27.7816 11.225L29.1499 11.2224Z",
  fill: "#8E8B99"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M28.7402 3.40668C26.6658 1.33227 23.8879 0.185547 20.9244 0.185547L20.927 1.55646C23.5194 1.55646 25.9649 2.5563 27.779 4.40909C29.5931 6.22323 30.6316 8.66872 30.6316 11.2611H32.0026C32 8.25899 30.8533 5.48109 28.7402 3.40668Z",
  fill: "#8E8B99"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M20.927 5.59189V6.9628C22.0763 6.9628 23.1122 7.40603 23.9265 8.22033C24.7408 9.03463 25.184 10.0731 25.184 11.2198H26.555C26.555 9.69947 25.9623 8.29506 24.9264 7.25657C23.8518 6.18458 22.4448 5.59189 20.927 5.59189Z",
  fill: "#8E8B99"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M2.85266 20.7776C2.85266 22.9628 3.70562 25.0372 5.25949 26.5911C6.81594 28.1475 8.89035 28.9979 11.073 28.9979V27.627C9.25885 27.627 7.51686 26.9235 6.22068 25.6273C4.92449 24.3312 4.221 22.6278 4.221 20.775L2.85266 20.7776Z",
  fill: "#8E8B99"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M3.25978 28.5933C5.33419 30.6678 8.1121 31.8145 11.0755 31.8145L11.073 30.4436C8.48059 30.4436 6.03511 29.4437 4.22097 27.5909C2.40683 25.7794 1.37091 23.3339 1.37091 20.7415H0C0 23.741 1.14672 26.5189 3.25978 28.5933Z",
  fill: "#8E8B99"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M11.0729 26.4081V25.0372C9.92361 25.0372 8.88769 24.594 8.07339 23.7797C7.25909 22.9654 6.81586 21.9269 6.81586 20.7802H5.44495C5.44495 22.3005 6.03763 23.7049 7.07355 24.7434C8.14812 25.8154 9.55511 26.4081 11.0729 26.4081Z",
  fill: "#8E8B99"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M11.2224 2.85263C9.03719 2.85263 6.96278 3.70559 5.4089 5.25946C3.85245 6.81591 3.00208 8.89032 3.00208 11.073H4.37299C4.37299 9.25882 5.07648 7.51683 6.37267 6.22065C7.66885 4.92446 9.37218 4.22097 11.225 4.22097L11.2224 2.85263Z",
  fill: "#8E8B99"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M3.40668 3.25978C1.33227 5.33419 0.185547 8.1121 0.185547 11.0755L1.55646 11.073C1.55646 8.48059 2.5563 6.03511 4.40909 4.22097C6.22066 2.40683 8.66614 1.37091 11.2585 1.37091V0C8.25899 0 5.48109 1.14672 3.40668 3.25978Z",
  fill: "#8E8B99"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M5.59192 11.073H6.96283C6.96283 9.92367 7.40606 8.88775 8.22036 8.07345C9.03466 7.25915 10.0732 6.81592 11.2199 6.81592V5.44501C9.6995 5.44501 8.29509 6.0377 7.2566 7.07361C6.18461 8.14818 5.59192 9.55517 5.59192 11.073Z",
  fill: "#8E8B99"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M20.7776 29.15C22.9628 29.15 25.0372 28.297 26.5911 26.7431C28.1475 25.1867 28.9979 23.1123 28.9979 20.9296H27.627C27.627 22.7438 26.9235 24.4858 25.6273 25.7819C24.3312 27.0781 22.6278 27.7816 20.775 27.7816L20.7776 29.15Z",
  fill: "#8E8B99"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "M28.5933 28.7402C30.6677 26.6658 31.8144 23.8879 31.8144 20.9245L30.4435 20.927C30.4435 23.5194 29.4437 25.9649 27.5909 27.779C25.7767 29.5932 23.3313 30.6317 20.7389 30.6317V32.0026C23.741 32 26.5189 30.8533 28.5933 28.7402Z",
  fill: "#8E8B99"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  d: "M26.4081 20.927H25.0372C25.0372 22.0763 24.594 23.1122 23.7797 23.9265C22.9654 24.7409 21.9269 25.1841 20.7802 25.1841V26.555C22.3005 26.555 23.7049 25.9623 24.7434 24.9264C25.8154 23.8518 26.4081 22.4448 26.4081 20.927Z",
  fill: "#8E8B99"
});

var SvgInventoryIcon = function SvgInventoryIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgInventoryIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/inventoryIcon.f0528b2a.svg";
export { ForwardRef as ReactComponent };